const os = require('os');
const process = require('process');
const pkg = require('../../package.json');
const clientParameters = require('../../parameters/client/config');
const serverParameters = require('../../parameters/server/config.js');
const DomainsConfig = require('../../parameters/countries/domains.json');
const DomainsReader = require('./domains-reader');

const domainSuffix = serverParameters.trovit_suffix || '';
const testingServerPrefix = process.env.TESTING_PREFIX || '';
const domains = DomainsReader(testingServerPrefix, domainSuffix, DomainsConfig);
const appEnvironment = serverParameters.appEnvironment;
const environment = process.env.NODE_ENV || appEnvironment;

const config = {
  appEnvironment,
  environment,
  port: process.env.PORT || 3000,
  version: pkg.version,
  hostname: os.hostname(),

  // Domains config
  domains,
};

module.exports = Object.assign(config, serverParameters, clientParameters);



// WEBPACK FOOTER //
// ./server/config/index.js